export default __webpack_public_path__ + "static/media/gensDeConfiance.90623b96.png";